var map = {
	"./Amber/Emberwing.json": 56397,
	"./Amber/Moonlight.json": 43726,
	"./Amber/Tessara.json": 88852,
	"./Beryl/Hootlet.json": 5920,
	"./Beryl/Kala.json": 75437,
	"./Beryl/Zygdra.json": 41393,
	"./Common/Scavy.json": 24968,
	"./Pearl/Bubbles.json": 24242,
	"./Pearl/Gigi.json": 16178,
	"./Pearl/Percy.json": 43247,
	"./Ruby/Burgly.json": 40134,
	"./Ruby/Flare.json": 73890,
	"./Ruby/Pepper.json": 2608,
	"./Spinelle/Bumper.json": 43362,
	"./Spinelle/Flicker.json": 90975,
	"./Spinelle/Mochi.json": 36846,
	"./Unused/Fye.json": 95398,
	"./Unused/Levi.json": 69324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49220;